import React from "react";
import { useNavigate } from "react-router-dom";

export default function UI_Ribbon({ Ribbon }) {
    const navigate = useNavigate();

    return (
        <ui-ribbon id="Ribbon" State={Ribbon.Active ? "Active" : "Inactive"}>
            {Ribbon.Active() ?
                <ui-ribbon-group id="Ribbon_Group" State="Active">
                    {Ribbon.Contents.map((item, index) =>
                        item.Active() ? (
                            <button
                                key={index}
                                className="Ribbon_Item"
                                onClick={() =>
                                    item.Destination
                                        ? navigate(item.Destination)
                                        : item.Action?.()
                                }
                            >
                                <img
                                    className="Ribbon_Item_Icon"
                                    src={item.Icon}
                                    draggable="false"
                                    loading="lazy"
                                    alt=""
                                />
                                <p className="Ribbon_Item_Text">{item.Text}</p>
                            </button>
                        ) : null
                    )}
                </ui-ribbon-group>
                :
                ""
            }
            
        </ui-ribbon>
    );
}
